import script from "./BookingNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingNav.vue?vue&type=script&setup=true&lang=js"

import "./BookingNav.vue?vue&type=style&index=0&id=4ace03e8&lang=css"
import "./BookingNav.vue?vue&type=style&index=1&id=4ace03e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ace03e8"]])

export default __exports__